<template>
  <svg
    class="GroupIcon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2473_22"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" />
    </mask>
    <g mask="url(#mask0_2473_22)">
      <path
        d="M1.79813 19.3076V17.0846C1.79813 16.5692 1.93114 16.1093 2.19718 15.7048C2.46319 15.3003 2.81846 14.9856 3.26298 14.7607C4.21333 14.2959 5.16894 13.9375 6.12983 13.6856C7.09073 13.4337 8.14682 13.3077 9.2981 13.3077C10.4494 13.3077 11.5055 13.4337 12.4664 13.6856C13.4273 13.9375 14.3829 14.2959 15.3332 14.7607C15.7777 14.9856 16.133 15.3003 16.399 15.7048C16.665 16.1093 16.7981 16.5692 16.7981 17.0846V19.3076H1.79813ZM18.7981 19.3076V16.9615C18.7981 16.3051 18.6373 15.6795 18.3159 15.0848C17.9945 14.49 17.5385 13.9797 16.9481 13.5538C17.6186 13.6538 18.2551 13.8087 18.8577 14.0183C19.4602 14.2279 20.0352 14.4756 20.5827 14.7615C21.0993 15.0372 21.4984 15.362 21.7798 15.7361C22.0612 16.1102 22.2019 16.5187 22.2019 16.9615V19.3076H18.7981ZM9.2981 11.6922C8.33562 11.6922 7.51167 11.3495 6.82625 10.6641C6.14083 9.97873 5.79813 9.15478 5.79813 8.1923C5.79813 7.2298 6.14083 6.40585 6.82625 5.72045C7.51167 5.03503 8.33562 4.69232 9.2981 4.69232C10.2606 4.69232 11.0845 5.03503 11.77 5.72045C12.4554 6.40585 12.7981 7.2298 12.7981 8.1923C12.7981 9.15478 12.4554 9.97873 11.77 10.6641C11.0845 11.3495 10.2606 11.6922 9.2981 11.6922ZM17.9326 8.1923C17.9326 9.15478 17.5899 9.97873 16.9045 10.6641C16.2191 11.3495 15.3951 11.6922 14.4327 11.6922C14.3198 11.6922 14.1763 11.6794 14.0019 11.6538C13.8276 11.6282 13.684 11.6 13.5712 11.5692C13.9655 11.0951 14.2686 10.5691 14.4804 9.99127C14.6922 9.41344 14.7981 8.81338 14.7981 8.1911C14.7981 7.56883 14.69 6.97116 14.474 6.39807C14.258 5.82501 13.9571 5.29745 13.5712 4.8154C13.7147 4.76411 13.8583 4.73078 14.0019 4.7154C14.1455 4.70001 14.2891 4.69232 14.4327 4.69232C15.3951 4.69232 16.2191 5.03503 16.9045 5.72045C17.5899 6.40585 17.9326 7.2298 17.9326 8.1923ZM3.2981 17.8076H15.2981V17.0846C15.2981 16.8756 15.2459 16.6897 15.1414 16.5269C15.0369 16.3641 14.8712 16.2217 14.6443 16.0999C13.8212 15.6756 12.9737 15.3541 12.102 15.1355C11.2302 14.9169 10.2955 14.8076 9.2981 14.8076C8.30067 14.8076 7.36605 14.9169 6.49425 15.1355C5.62247 15.3541 4.77503 15.6756 3.95195 16.0999C3.72503 16.2217 3.55933 16.3641 3.45483 16.5269C3.35034 16.6897 3.2981 16.8756 3.2981 17.0846V17.8076ZM9.2981 10.1923C9.8481 10.1923 10.3189 9.99646 10.7106 9.6048C11.1023 9.21313 11.2981 8.7423 11.2981 8.1923C11.2981 7.6423 11.1023 7.17146 10.7106 6.7798C10.3189 6.38813 9.8481 6.1923 9.2981 6.1923C8.7481 6.1923 8.27727 6.38813 7.8856 6.7798C7.49393 7.17146 7.2981 7.6423 7.2981 8.1923C7.2981 8.7423 7.49393 9.21313 7.8856 9.6048C8.27727 9.99646 8.7481 10.1923 9.2981 10.1923Z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'GroupIcon',
};
</script>

<style lang="scss" scoped>
.GroupIcon {
  width: 100%;
  height: auto;
  fill: currentcolor;
}
</style>
